import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

export const getAgentRecords = async () => {
  try {
    const agentsRef = collection(db, 'plsss_agents');
    const querySnapshot = await getDocs(agentsRef);
    
    const agents = [];
    
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      agents.push({
        id: doc.id,
        ...data
      });
    });
    
    // Build hierarchy - identify team leaders by checking if other agents have them as teamLeader
    const agentsWithHierarchy = agents.map(agent => {
      const children = [];
      
      // Find all agents that have this agent as their team leader
      agents.forEach(otherAgent => {
        if (otherAgent.apps?.agents?.teamLeader === agent.agent_id) {
          children.push({
            agent_id: otherAgent.agent_id,
            name: otherAgent.name,
            phoneno: otherAgent.phoneno,
            email: otherAgent.email,
            apps: otherAgent.apps // Include the full apps object to access role
          });
        }
      });
      
      return {
        ...agent,
        isTeamLeader: children.length > 0,
        children: children.length > 0 ? children : undefined
      };
    });
    
    // Return all agents without filtering
    return agentsWithHierarchy;
  } catch (error) {
    console.error('Error fetching agent records:', error);
    throw error;
  }
};
